import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

const StyledBetaTag = styled.span`
  ${({
    theme: {
      colors: { fillBrand, staticWhite },
      typography: {
        subheads: {
          xsmall2: { bundledCSS: xsmall2 },
        },
      },
      spacing: { spacing4 },
    },
  }) => css`
    color: ${staticWhite};
    background-color: ${fillBrand};
    text-align: center;
    padding: 0 ${spacing4};
    text-transform: none;
    border-radius: ${spacing4};
    height: fit-content;
    ${xsmall2};
    min-height: 14px;
    box-sizing: border-box;
    white-space: nowrap;
  `}
`

const ChatbotBetaTag: FunctionComponent<{ className?: string }> = ({
  className,
}) => {
  return <StyledBetaTag className={className}>Beta</StyledBetaTag>
}

export default ChatbotBetaTag
